import {forwardRef} from 'react';
import styled from 'styled-components';

const RadioButton = styled.div`
  position: relative;
  display: inline-block;
  vertical-align: top;
  width: 24px;
  height: 24px;
  border-radius: 26px;
  border: ${({theme}) => theme.radio.default.border};
  background: ${({theme}) => theme.radio.default.bg};
  margin: 0 8px 0 0;
`;

const Label = styled.label`
  position: relative;
  display: block;
  margin: 0 0 12px;

  & input {
    position: absolute;
    left: 0;
    top: 0;
    opacity: 0;
  }

  & input:checked + ${RadioButton} {
    border: ${({theme}) => theme.radio.checked.border};
    background: ${({theme}) => theme.radio.checked.bg};

    &::after {
      content: '';
      position: absolute;
      left: 50%;
      top: 50%;
      width: 10px;
      height: 10px;
      transform: translate(-50%, -50%);
      background: ${({theme}) => theme.radio.checked.innerBg};
      border-radius: 12px;
    }
  }
`;

const Radio = forwardRef(({label, ...props}, ref) => (
  <Label>
    <input type="radio" {...props} ref={ref} />
    <RadioButton />
    {label}
  </Label>
));

export default Radio;
